module.exports = __webpack_public_path__ + "static/media/logo-dark.be9c266a.png";